import { FunctionComponent, ReactNode } from "react";

import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/system";

interface LinksContainerProps {
  topLevel?: boolean;
  children: ReactNode;
}

export const LinksContainer: FunctionComponent<LinksContainerProps> = ({
  children,
  topLevel = false,
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        columnGap: "38px",
        rowGap: "16px",
        flexWrap: "wrap",
        [theme.breakpoints.up("desktop")]: {
          justifyContent: topLevel ? "right" : "unset",
        },
      }}
    >
      {children}
    </Box>
  );
};
